import React, { useCallback } from "react";
import TextField from "components/Controls/TextField";
const TextInput = ({ value = "", onChange, type, textarea = false, className, readonly, ...attributes }) => {
    const handleKeyPress = useCallback((event) => {
        if (event.key === "Enter" && !textarea) {
            event.preventDefault();
        }
    }, [textarea]);
    const handleBlur = useCallback((e) => {
        onChange(value.trim());
        attributes.onBlur && attributes.onBlur(e);
    }, [attributes, onChange, value]);
    return (React.createElement(TextField, { value: value, onChange: (e) => onChange(e.target.value), onKeyPress: handleKeyPress, textarea: textarea, type: type, classes: {
            container: className,
        }, outlined: false, readonly: readonly, ...attributes, onBlur: handleBlur }));
};
export default TextInput;
